export default "/kiban/_next/static/images/26_8L_2-4-2_withBH_fullstack-09378f340e7686d1551b2b6e8d2d97ae.png";